
     $(document).ready(function(){
      $('.testimonial_slider_code').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });
    });


$(document).ready(function () {
  function calculateWeightLoss() {
    let weightLbs = parseInt($("#calc-weight_value").val(), 10);
    const selectedUnit = $("#weight-unit-selector").val();

    // Clamp to valid range
    if (isNaN(weightLbs) || weightLbs < 1) {
      weightLbs = 1;
    } else if (weightLbs > 400) {
      weightLbs = 400;
    }

    // Update input and slider
    $("#calc-weight_value").val(weightLbs);
    $("#calc-weight").val(weightLbs);

    // Calculate result
    const weightLossLbs = Math.round(weightLbs * 0.20);
    const weightLossKg = Math.round(weightLossLbs * 0.453592);

    if (selectedUnit === "lbs") {
      $("#lose-value").html(weightLossLbs);
      $("#lose-unit").html("lbs");
    } else {
      $("#lose-value").html(weightLossKg);
      $("#lose-unit").html("kg");
    }
  }

  function syncSliderToInput() {
    const sliderVal = parseInt($("#calc-weight").val(), 10);
    $("#calc-weight_value").val(sliderVal);
    calculateWeightLoss();
  }

  // Event listeners
  $("#calc-weight, #weight-unit-selector").on("input change", syncSliderToInput);

  $("#calc-weight_value").on("input", function () {
    let val = parseInt($(this).val(), 10);

    // Clamp the value while typing
    if (isNaN(val) || val < 1) {
      val = 1;
    } else if (val > 400) {
      val = 400;
    }

    $(this).val(val);
    $("#calc-weight").val(val);
    calculateWeightLoss();
  });

  // Initial calculation
  calculateWeightLoss();
});

// About Counter
document.addEventListener("DOMContentLoaded", function () {
  const loader = document.querySelector('.about-us-stats');
  if (!loader) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio === 1) {
        const counters = document.querySelectorAll('.count__start_pt');
        counters.forEach(counter => {
          if (counter.classList.contains('animated')) return;
          counter.classList.add('animated');

          const target = parseInt(counter.textContent.replace(/,/g, ''), 10);
          const duration = 3000;
          const startTime = performance.now();

          function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const current = Math.floor(progress * target);
            counter.textContent = current.toLocaleString();

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
        });
      }
    });
  }, {
    threshold: 1.0
  });

  observer.observe(loader);
});



// $(document).ready(function () {
//   $('.custom_megamenu-2').on('click', function () {
//     $('.custom_megamenu-1 ul').css('display', 'none'); 
//     $('.custom_megamenu-2 ul').css('display', 'block');
//     $('.weighloss-card').css('display','none');
//     $('.anti-aging_card').css('display','block');
//   });

//   $('.custom_megamenu-1').on('click', function () {
//     $('.weighloss-card').css('display','block');
//     $('.anti-aging_card').css('display','none');
//     $('.custom_megamenu-2 ul').css('display', 'none'); 
//     $('.custom_megamenu-1 ul').css('display', 'block');
//   });
// });
$(document).ready(function () {
  // Default state
  $('.custom_megamenu-1 ul').css('display', 'block');
  $('.custom_megamenu-2 ul, .custom_megamenu-3 ul, .custom_megamenu-4 ul').css('display', 'none');
  $('.weighloss-card').css('display','block');
  $('.anti-aging_card, .engery_mood, .supplements, .custom_megamenu-3 ul, .custom_megamenu-4 ul').css('display','none');

  // Menu 1 click
  $('.custom_megamenu-1').on('click', function () {
    $('.custom_megamenu-1 ul').css('display', 'block');
    $('.custom_megamenu-2 ul, .custom_megamenu-3 ul, .custom_megamenu-4 ul').css('display', 'none');
    $('.weighloss-card').css('display','block');
    $('.anti-aging_card, .engery_mood, .supplements, .custom_megamenu-3 ul, .custom_megamenu-4 ul').css('display','none');
  });

  // Menu 2 click
  $('.custom_megamenu-2').on('click', function () {
    $('.custom_megamenu-2 ul').css('display', 'block');
    $('.custom_megamenu-1 ul, .custom_megamenu-3 ul, .custom_megamenu-4 ul').css('display', 'none');
    $('.anti-aging_card').css('display','block');
    $('.weighloss-card, .engery_mood, .supplements, .custom_megamenu-3 ul, .custom_megamenu-4 ul').css('display','none');
  });

  // Menu 3 click
  $('.custom_megamenu-3').on('click', function () {
    $('.custom_megamenu-3 ul').css('display', 'block');
    $('.custom_megamenu-1 ul, .custom_megamenu-2 ul, .custom_megamenu-4 ul').css('display', 'none');
    $('.custom_megamenu-3').css('display','block');
    $('.engery_mood').css('display','block');
    $('.weighloss-card, .anti-aging_card, .supplements, .custom_megamenu-4 ul').css('display','none');
  });

  // Menu 4 click
  $('.custom_megamenu-4').on('click', function () {
    $('.custom_megamenu-4 ul').css('display', 'block');
    $('.custom_megamenu-1 ul, .custom_megamenu-2 ul, .custom_megamenu-3 ul').css('display', 'none');
    $('.custom_megamenu-4').css('display','block');
    $('.supplements').css('display','block');
    $('.weighloss-card, .anti-aging_card, .engery_mood, .custom_megamenu-3 ul').css('display','none');
  });
});




